/* eslint-disable react/no-danger */
import React from 'react';

const StringIcon = ({ value, iconKeyWord, iconSrc }) => {
    let paraText = '';
    value.split(' ').forEach(item => {
        if (item.toUpperCase() === iconKeyWord) {
            paraText += ` <img src=${iconSrc} /> `;
        } else {
            paraText += `${item} `;
        }
    });
    return (
        <div>
            <span
                dangerouslySetInnerHTML={{
                    __html: paraText,
                }}
            ></span>
        </div>
    );
};

export default StringIcon;
